import { Languages, IndianRupee, Eye, EyeClosed } from 'lucide-react';
import moment from 'moment';

function CourseDetails({ close, setRefresh, currentClass }) {

    // console.log(currentClass,'cur')

    return (
        <div className=" py-4 px-2 sm:px-1 lg:px-2">
            <div className="mx-auto bg-white rounded-2xl shadow-lg overflow-hidden">
                {/* Course Image */}
                <div className="relative h-72 w-full">
                    <div className="flex h-full">
                        <div className="w-1/2">
                            <img
                                src={`${process.env.REACT_APP_IMAGE_URI}${currentClass?.image}`}
                                alt={currentClass?.title}
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="w-1/2">
                            <img
                                src={`${process.env.REACT_APP_IMAGE_URI}${currentClass?.backgroundImage}`}
                                alt={currentClass?.title}
                                className="w-full h-full object-cover"
                            />
                        </div>

                    </div>
                    <div className={`absolute top-4 right-4 ${currentClass?.status === "Active" ? "bg-green-500" : "bg-red-500"} text-white px-3 py-1 rounded-full text-sm font-medium`}>
                        {currentClass?.status}
                    </div>
                </div>

                {/* Course Content */}
                <div className="p-8">
                    {/* Header Section */}
                    <div className="mb-6">
                        <div className="items-center justify-between mb-2">
                            <h1 className="text-3xl font-bold text-gray-900">{currentClass?.title}</h1>
                            <div className="flex items-center gap-1">
                                <Languages className="w-5 h-5 fill-purple-500 text-purple-400" />
                                <span className="text-lg font-semibold">{currentClass?.language}</span>
                            </div>
                        </div>
                        <div className="flex flex-col gap-4 text-sm text-gray-600">
                            <span>{currentClass?.priceText}: <span className='font-semibold'>{currentClass?.price}</span> </span>
                            <span>{currentClass?.dateText} : <span className='font-semibold'>{moment(currentClass?.date).format('Do-MMM-YYYY')}</span></span>
                            <span> {currentClass?.timeText} : <span className='font-semibold'>{currentClass?.time}</span></span>
                            <span>Booking Link: <span className='font-semibold break-words'>{currentClass?.pageLink}</span></span>
                            <span>Date Fromat: <span className='font-semibold'>{currentClass?.dateFormat}</span></span>
                            {/* <span>End Date: <span className='font-semibold'>{moment(currentClass?.endDate).format('Do-MMM-YYYY')}</span></span>
                            <span>Notes: <span className='font-semibold break-words'>{currentClass?.notes}</span></span> */}
                        </div>
                    </div>

                    {/* Stats Grid */}
                    <div className="grid grid-cols-2 md:grid-cols-2 gap-4 mb-8">
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <div className="flex items-center gap-2 text-gray-600 mb-1">
                                <IndianRupee className="w-4 h-4" />
                                <span>Price</span>
                            </div>
                            <p className="text-xl font-bold">{currentClass?.price}</p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <div className="items-center gap-2 text-gray-600 mb-1">
                                {currentClass?.joinBtn? <Eye className="w-4 h-4" />: <EyeClosed className="w-4 h-4" />}
                                <span>{currentClass?.joinBtn? "Show":"Hide"} <br />Join Button</span>
                            </div>
                            {/* <p className="font-bold">{currentClass?.deliveryMethod}</p> */}
                        </div>
                        {/* <div className="bg-gray-50 p-4 rounded-lg">
                            <div className="flex items-center gap-2 text-gray-600 mb-1">
                                <Clock className="w-4 h-4" />
                                <span>Priority</span>
                            </div>
                            <p className="text-xl font-bold">{currentClass?.precedence}</p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <div className="flex flex-col">
                                <span className="text-gray-600">Price</span>
                                <div className="flex items-center gap-2 flex-wrap">
                                    <span className="text-xl font-bold">{discountedPrice.toFixed(2)}</span>
                                    <div>
                                        <span className="text-sm text-gray-500 line-through mr-2">{currentClass?.price}</span>
                                        <span className="text-green-500 text-sm">-{currentClass?.discount_percentage}%</span>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>

                    {/* Description */}
                    {/* <div className="mb-8">
                        <h2 className="text-xl font-semibold mb-4">Class Description</h2>
                        <p className="text-gray-600 leading-relaxed">
                            {currentClass?.description}
                        </p>
                    </div> */}

                    {/* CTA Button */}
                    {/* <button className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 transition-colors">
                        Enroll Now
                    </button> */}
                </div>
            </div>
        </div>
    );
}

export default CourseDetails;